import { env } from "configs/EnvironmentConfig";
import fetch from "../auth/FetchInterceptor";

const authenService = {};

authenService.loginUser = function (data) {
  return fetch({
    url: "/api/authenticate",
    method: "post",
    data: data,
  });
};

//get-registered-app
authenService.getRegisteredApp = function () {
  return fetch({
    url: `${env.API_MSCSM}/api/microservice-management/get-registered-app`,
    method: "get",
  });
};

// get final auth
authenService.getFinalAuth = function (data) {
  return fetch({
    url: `${env.API_MSCSM}/api/authorization/gen-app-jwt`,
    method: "post",
    data: data,
  });
};

// changePassword
authenService.changePassword = function (data) {
  return fetch({
    url: `${env.API_MSP}/my/change-password`,
    method: "post",
    data: data,
  });
};

export default authenService;
